import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AffiliateGridRoutingModule } from './affiliate-grid-routing.module';
import { AffiliateGridComponent } from './affiliate-grid.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ListGridModule } from '../../../shared/listGrid/listGrid.module';
import { LoadingModule } from '../../../shared/loading/loading.module';

@NgModule({
  declarations: [AffiliateGridComponent],
  imports: [
    CommonModule,
    AffiliateGridRoutingModule,
    ListGridModule,
    MatButtonModule,
    MatToolbarModule,
    MatIconModule,
    LoadingModule,
  ],
})
export class AffiliateGridModule {}
